import React from "react";

const Fleet = () => {
  const cars = [
    { name: "Maruti Ertiga", seats: 7, image: "https://www.team-bhp.com/forum/attachments/test-drives-initial-ownership-reports/2593740d1712911319-2024-maruti-ertiga-vxi-petrol-mild-hybrid-review-whatsapp-image-20240412-13.39.14.jpeg" },
    { name: "Swift Dzire", seats: 5, image: "https://mda.spinny.com/sp-file-system/public/2025-02-28/3f3e097d990e4a5b8c34a13633791b8d/raw/file.jpg" },
  ];

  const containerStyle = {
    textAlign: "center",
    padding: "clamp(10px, 5vw, 20px)",
    maxWidth: "800px",
    margin: "0 auto",
  };

  const carCardStyle = {
    border: "1px solid #ddd",
    margin: "10px auto",
    padding: "10px",
    width: "100%",
    maxWidth: "300px",
  };

  const imageStyle = {
    width: "100%",
    maxWidth: "400px",
    height: "auto",
  };

  return (
    <div style={containerStyle}>
      <h1>Our Fleet</h1>
      {cars.map((car, index) => (
        <div key={index} style={carCardStyle}>
          <h2>{car.name}</h2>
          <p>Seating Capacity: {car.seats}</p>
          <img src={car.image} alt={car.name} style={imageStyle} />
        </div>
      ))}
    </div>
  );
};

export default Fleet;